import { render, staticRenderFns } from "./LogoDieWelt.vue?vue&type=template&id=5f52108d&scoped=true&"
import script from "./LogoDieWelt.vue?vue&type=script&lang=js&"
export * from "./LogoDieWelt.vue?vue&type=script&lang=js&"
import style0 from "./LogoDieWelt.vue?vue&type=style&index=0&id=5f52108d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f52108d",
  null
  
)

export default component.exports